import { List, ListItem, ListItemText } from '@mui/material'

import { CardWithIcon } from '../../Design/Cards'

import CircularProgress from '@mui/material/CircularProgress'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'

const TasksList = ({ tasksInfo, loading }) => {
  const numberOfTasks = tasksInfo?.length || 0
  const numberOfTasksCompleted = tasksInfo?.filter(task => Number(task.progress) === 100).length || 0
  const numberOfTasksInProgress = tasksInfo?.filter(task => Number(task.progress) > 0 && Number(task.progress) < 100).length || 0
  const numberOfTasksNotStarted = tasksInfo?.filter(task => !task.progress || Number(task.progress) === 0).length || 0

  return (
    <div style={{ flex: 1 }}>
      <CardWithIcon
        to="/tasks"
        icon={AssignmentTurnedInIcon}
        title="Tâches assignées"
        subtitle={loading ? <CircularProgress size="15px" /> : numberOfTasks}
        color="primary.light"
      >
        <List>
          <ListItem>
            <ListItemText primary="Non commencées" secondary={numberOfTasksNotStarted} />
          </ListItem>

          <ListItem>
            <ListItemText primary="En cours" secondary={numberOfTasksInProgress} />
          </ListItem>

          <ListItem>
            <ListItemText primary="Terminées" secondary={numberOfTasksCompleted} />
          </ListItem>
        </List>
      </CardWithIcon>
    </div>
  )
}

export default TasksList